import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateBookCategoryModal, EditBookCategoryModal, BookCategoryListFilters } from "@modules/bookCategories/components";

import { useBookCategoriesList } from "./controller";
import { useBookCategoriesListColumns } from "./columns";

export const BookCategoriesList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createBookCategoriesModalRef,
    editBookCategoriesModalRef,
    setSelectedRows,
    refetch,
    translate,
  } =  useBookCategoriesList();

  const columns = useBookCategoriesListColumns(refetch, translate, editBookCategoriesModalRef);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <BookCategoryListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="book-categories.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createBookCategoriesModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateBookCategoryModal
        modalRef={createBookCategoriesModalRef}
        onComplete={refetch}
      />

      <EditBookCategoryModal
        modalRef={editBookCategoriesModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
